"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = function (props) {
    var className = props.className;
    return ({
        root: [
            'ms-Facepile',
            {
            // Insert css properties
            },
            className
        ],
    });
};
//# sourceMappingURL=Facepile.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Facepile/Facepile.styles.js
// module id = 1547
// module chunks = 0